/**
 * 号码包提取页面
 */
export default {
  dbl_extraction_title: "User Extraction",
  dbl_extraction_data_source_status: "Data Source Status",
  dbl_extraction_filter_conditions: "Filter Condition",
  dbl_extraction_extract_field: "Extract Field",
  dbl_extraction_extract_field_placeholder: "Please select extracted field",
  dbl_extraction_extract_field_info: "The extracted object of the number package can only be sensitive field.",
  dbl_extraction_package_type: "Package Type",
  dbl_extraction_static_package: "Static Package",
  dbl_extraction_updated_daily: "Updated Daily",
  dbl_extraction_package_name: "Package Name",
  dbl_extraction_package_name_placeholder: "Please enter package name",
  dbl_extraction_package_note: "Package Note",
  dbl_extraction_package_note_placeholder: "Please enter package note",
  dbl_extraction_save_success: "Save {name} Success",
  dbl_extraction_add_package: "Add Number Package",
};